import { useContext, useEffect, useState } from "react";

// context
import { errorContext } from "../../../context/error-provider/ErrorProvider";
import { blogContext } from "../../../context/blog-provider/BlogProvider";

export function useBlogScreenFetch() {
  const { error } = useContext(errorContext);
  const { getBlogs } = useContext(blogContext);

  const [isBlogsLoading, setIsBlogsLoading] = useState(false);

  const blogFetch = async () => {
    try {
      setIsBlogsLoading(true);

      await getBlogs();
    } catch (err) {
      error(err);
    } finally {
      setIsBlogsLoading(false);
    }
  };

  useEffect(() => {
    blogFetch();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isBlogsLoading,
  };
}
